import './web_header.css';
import React, { useState, useRef, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { MdAccountCircle, MdWorkHistory } from "react-icons/md";
import { AiOutlineHome, AiFillHome } from "react-icons/ai";
import { IoCallOutline, IoCallSharp } from "react-icons/io5";
import { RiSlideshowLine, RiSlideshowFill } from "react-icons/ri";
import { MdOutlineDocumentScanner, MdDocumentScanner, MdOutlineStore, MdStore } from "react-icons/md";
import { FaMessage, FaRegMessage } from "react-icons/fa6";
import Photosicon from '../assets/photos_icon.png';
import { IoSearchOutline,IoSearchSharp } from "react-icons/io5";
import Cookies from 'js-cookie';
import Logo from '../assets/callqr_logo.png'
export default function WebHeader() {
    const location = useLocation(); // Get current route
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [guid, setGuid] = useState("");
    const [photoURL, setPhotoURL] = useState("");
    const [isVisible, setIsVisible] = useState(false);
    const [userlogin, setuserlogin] = useState(false);
    useEffect(() => {
        const existingUser = Cookies.get("guid");
        if (existingUser != null) {
            setGuid(existingUser);
            setuserlogin(true);
            const photo = Cookies.get("login_photoURL");
            setPhotoURL(photo);
        } else {
            setuserlogin(false);
        }
    }, []);

    return (

        <div className='header'>
            <div className='left_body'>
                <img className='logo-img'  onClick={() => navigate('/')} src={Logo}></img>
            </div>
            <div className='menus_body' >
                <nav className="navbar">
                    <div
                        onClick={() => navigate('/')}
                        className={`menubutton-icon ${location.pathname === '/' ? 'active' : ''}`}
                        title="Home"
                    >
                        {location.pathname === '/' ? (
                            <AiFillHome className="icon" />
                        ) : (
                            <AiOutlineHome className="icon" />
                        )}

                        <span className="button-text">Home</span>
                    </div>
                    <div
                        onClick={() => navigate('/message')}
                        className={`menubutton-icon menubutton-nav ${location.pathname === '/message' ? 'active' : ''}`}
                        title="Message"
                    >

                        {location.pathname === '/message' ? (
                            <FaMessage className="icon" />
                        ) : (
                            <FaRegMessage className="icon" />
                        )}
                        <span className="button-text">Message</span>
                    </div>
                    <div
                        onClick={() => navigate('/history')}
                        className={`menubutton-nav menubutton-icon  ${location.pathname === '/history' ? 'active' : ''}`}
                        title="History"
                    >
                        {location.pathname === '/history' ? (
                            <MdDocumentScanner className="icon" />
                        ) : (
                            <MdOutlineDocumentScanner className="icon" />
                        )}
                        <span className="button-text">History</span>
                    </div>
                    <div
                        onClick={() => navigate('/tools')}
                        className={`menubutton-icon ${location.pathname === '/tools' ? 'active' : ''}`}
                        title="Tools"
                    >

                        {location.pathname === '/tools' ? (
                            <MdStore className="icon" />
                        ) : (
                            <MdOutlineStore className="icon" />
                        )}
                        <span className="button-text">Tools</span>
                    </div>
                

                </nav>
            </div>
            <div className='search-body'>
                {/* <div className='search-box'>
                    <input className="search-input"
                        placeholder="Search..." />
                    <div className='search-btn'>Search</div>
                </div> */}

            </div>
            <div className='right_body'>
                <div
                    onClick={() => navigate('/search')}
                    className={`menubutton-icon ${location.pathname === '/search' ? 'active' : ''}`}
                    title="Search"
                >
                    {location.pathname === '/search' ? (
                        <IoSearchSharp className="icon" />
                    ) : (
                        <IoSearchOutline className="icon" />
                    )}
                    {/* <span className="button-text">Search</span> */}
                </div>
                <div

                    onClick={() => navigate('/settings')}
                    className={`menubutton-icon ${location.pathname === '/settings' ? 'active' : ''}`}
                    title="settings"
                >
                    <img
                        className="img-icon"
                        src={photoURL}
                        alt="User"
                        onError={(e) => {
                            e.target.onerror = null; // prevent infinite loop
                            e.target.src = Photosicon;
                        }}
                    />
                </div>
            </div>
        </div>
    );

}